import {
  BeaconEventMarketingPageElementLocation,
  BeaconEventMarketingPageElementType,
  PageContext,
  ExtendedDrupal,
  ExtendedDrupalData as EDrupalData,
  ExtendedDrupalNode,
  ExtendedPageTemplateProps as EPageTemplateProps,
  I18nDataEdges,
  isDefined,
  LinkInterface,
  PageMarketoExtraData,
  PageMetatag,
  PageTemplateProduct,
  PageTemplateProps,
  WeekDay
} from '@lucid/utils';
import {
  Maybe,
  Scalars,
  DemoRequestClientsJsonConnection,
  EnterpriseHeaderLogosJsonConnection,
  ProductTemplatesJsonConnection
} from 'generated/drupal-graphql';
import {
  CarouselHeroSliderLink as ICarouselHeroSliderLink,
  CarouselHeroSliderItems as ICarouselHeroSliderItems
} from '@lucid/components-react';

export interface ExtendedDrupalData extends EDrupalData {
  allDemoRequestClientsJson?: DemoRequestClientsJsonConnection;
  allEnterpriseHeaderLogosJson?: EnterpriseHeaderLogosJsonConnection;
  allProductTemplatesJson?: ProductTemplatesJsonConnection;
}

export interface ExtendedPageTemplateProps extends Omit<EPageTemplateProps, 'data'> {
  data: ExtendedDrupalData;
}

export interface TemplateCategoryPage {
  slug: string;
  name: string;
  subtitle?: string;
}

export interface RelatedTemplate {
  id: string;
  path: string;
  title: string;
}

// Placeholder of Drupal_Entity for when we need it in gasby-node
export interface TempDrupalNode {
  status: boolean;
  entityLanguage: {
    id: string;
  };
  entityUrl: {
    path: string;
  };
  entityQueryExclusive: {};
}

export interface MarketoFormField {
  targetId?: Maybe<Scalars['Int']>;
  entity?: Maybe<any>;
  targetRevisionId?: Maybe<Scalars['Int']>;
}

export enum Template {
  CaseStudy = 'case_study',
  CaseStudyHub = 'case_study_hub',
  CloudInsights = 'cloud_insights',
  CloudInsightsHub = 'cloud_insights_hub',
  Consideration = 'consideration',
  ConsiderationCompetitor = 'consideration-competitor',
  ConsiderationPpc = 'consideration_ppc',
  DemoRequest = 'demo_request',
  Discovery = 'discovery',
  Documentation = 'documentation',
  Ebook = 'ebook',
  Enterprise = 'enterprise',
  EnterpriseRegistration = 'enterprise_registration',
  FifteenIntegration = 'fifteen_integration',
  FifteenIntegrationPpc = 'fifteen_integration_ppc',
  FifteenOg = 'fifteen_og',
  FifteenOgCompetitor = 'fifteen_og_competitor',
  FifteenOgPpc = 'fifteen_og_ppc',
  FunFlowchart = 'fun_flowchart',
  FunFlowchartHub = 'fun_flowchart_hub',
  Homepage = 'homepage',
  IndividualRole = 'individual_role',
  IntegrationHub = 'integration_hub',
  Nineteen = 'nineteen',
  NineteenSolutions = 'nineteen_solutions',
  ProductTemplate = 'product_template',
  ProductTemplateHub = 'product_template_hub',
  RolesHub = 'roles_hub',
  SolutionsHub = 'solutions_hub',
  Sunrise = 'sunrise',
  TwentyoneEnterprise = 'twentyone_enterprise',
  TwentyoneHomepage = 'twentyone_homepage',
  Webinar = 'webinar',
  WebinarHub = 'webinar_hub',
  WhitePaper = 'white_paper'
}

export type CarouselHeroSliderItems = ICarouselHeroSliderItems;
export type CarouselHeroSliderLink = ICarouselHeroSliderLink;

export {
  BeaconEventMarketingPageElementLocation,
  BeaconEventMarketingPageElementType,
  ExtendedDrupal,
  ExtendedDrupalNode,
  I18nDataEdges,
  isDefined,
  LinkInterface,
  PageContext,
  PageMarketoExtraData,
  PageMetatag,
  PageTemplateProduct,
  PageTemplateProps,
  WeekDay
};
